import React from "react";
import { Link } from "react-router-dom";
import { SwiperSlide, Swiper } from "swiper/react";
import "swiper/css/bundle";

const LocationLinks = () => {
  return (
    <>
      <Swiper
        className="region-button"
        spaceBetween={10} // Space between slides
        breakpoints={{
          425: {
            slidesPerView: 2, // Show 2 slides on small screens
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 4, // Show 4 slides on tablets
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 4, // Show based on content on larger screens
            spaceBetween: 10,
          },
        }}
        freeMode={true} // Enable free scrolling
        style={{
          padding: "10px 0px", // Padding around text
        }}
      >
        <SwiperSlide className="property-review-slider">
          <div>
            <div>
              <ul className="footer-link-ul">
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Titwala"
                  >
                    Flat in titwala
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Kalyan"
                  >
                    Flat in Kalyan East
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Kalyan"
                  >
                    Flat in kalyan west
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Shahad"
                  >
                    Flat in Shahad East
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="property-review-slider">
          <div>
            <div>
              <ul className="footer-link-ul">
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Dombivali"
                  >
                    Flat in Dombivli East
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Shilphata"
                  >
                    Flat in Shilphata
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="property-review-slider">
          <div>
            <div>
              <ul className="footer-link-ul">
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Badlapur"
                  >
                    Flat in badlapur
                  </Link>
                </li>

                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Mulund"
                  >
                    Flat in Mulund East
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Taloja"
                  >
                    Flat in Taloja
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="property-review-slider">
          <div>
            <div>
              <ul className="footer-link-ul">
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Panvel"
                  >
                    Flat in Panvel
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Bhandup"
                  >
                    Flat in Bhandup west
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Vikroli"
                  >
                    Flat in vikhroli east
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="property-review-slider">
          <div>
            <div>
              <ul className="footer-link-ul">
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Virar"
                  >
                    Flat in virar west
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </>
  );
};

export default LocationLinks;
